export enum HomeScreens {
  HOME_SCREEN = "HomePage",
  BALANCE_SCREEN = "Balance",
  POINT_OF_SALE_STACK = "POS",
  PROFILE_STACK = "Profile",
  ARTICLE_SCREEN = "Article",
  OFFER_DETAIL_SCREEN = "OfferDetail",
  ORDER_CHECKOUT_SCREEN = "OrderCheckout",
  MAINTENANCE_SCREEN = "Maintenance",
  IDPCallback = "IDPCallback",
  CodeExchange = "CodeExchange",
  LOGOUT = "Logout",
}
